// Notification types with visual styling and behavior
export const NOTIFICATION_TYPES = {
  URGENT: {
    color: '#dc3545',
    backgroundColor: '#f8d7da',
    borderColor: '#f5c6cb',
    icon: 'exclamation-triangle',
    duration: 0, // Persistent until dismissed
    sound: 'urgent',
    priority: 1
  },
  IMPORTANT: {
    color: '#fd7e14',
    backgroundColor: '#fff3cd',
    borderColor: '#ffeaa7',
    icon: 'exclamation-circle',
    duration: 15000,
    sound: 'important',
    priority: 2
  },
  INFO: {
    color: '#0d6efd',
    backgroundColor: '#cce7ff',
    borderColor: '#b3d9ff',
    icon: 'info-circle',
    duration: 8000,
    sound: 'info',
    priority: 3
  },
  SUCCESS: {
    color: '#198754',
    backgroundColor: '#d1e7dd',
    borderColor: '#badbcc',
    icon: 'check-circle',
    duration: 5000,
    sound: 'success',
    priority: 4
  }
};

// Notification categories
export const NOTIFICATION_CATEGORIES = {
  APPROVAL: 'approval',
  RELEASE: 'release',
  PAYMENT: 'payment',
  SYSTEM: 'system',
  REMINDER: 'reminder'
};

// Notification actions
export const NOTIFICATION_ACTIONS = {
  VIEW: { 
    label: 'View', 
    icon: 'eye', 
    variant: 'primary',
    size: 'sm'
  },
  APPROVE: { 
    label: 'Quick Approve', 
    icon: 'check', 
    variant: 'success',
    size: 'sm'
  },
  APPROVE_ALL: { 
    label: 'Approve All', 
    icon: 'check', 
    variant: 'success',
    size: 'sm'
  },
  SNOOZE: { 
    label: 'Snooze', 
    icon: 'clock', 
    variant: 'warning',
    size: 'sm'
  },
  DEFER: { 
    label: 'Remind Later', 
    icon: 'calendar', 
    variant: 'secondary',
    size: 'sm'
  },
  DISMISS: { 
    label: 'Dismiss', 
    icon: 'times', 
    variant: 'outline-secondary',
    size: 'sm'
  }
};

// Map notification types to categories
export const getNotificationType = (category, isUrgent = false) => {
  if (isUrgent) return 'URGENT';
  
  switch (category) {
    case NOTIFICATION_CATEGORIES.APPROVAL:
      return 'IMPORTANT';
    case NOTIFICATION_CATEGORIES.RELEASE:
      return 'IMPORTANT';
    case NOTIFICATION_CATEGORIES.PAYMENT:
      return 'INFO';
    case NOTIFICATION_CATEGORIES.SYSTEM:
      return 'INFO';
    case NOTIFICATION_CATEGORIES.REMINDER:
      return 'INFO';
    default:
      return 'INFO';
  }
};